module.exports = __webpack_public_path__ + "bamboo_plan.png";